module.exports = __webpack_public_path__ + "static/media/undraw_online_collaboration_7pfp.e7cb45a5.svg";